import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

import { GetCustomerAccountHistoryDocument } from '../../../../graphql/camel'
import useCamelQuery from '../../../../hooks/useCamelQuery'
import useLogAndCaptureError from '../../../../hooks/useLogAndCaptureError'
import Spinner from '../../../Spinner'
import HeaderWithSecondaryButton from '../HeaderWithSecondaryButton'
import CurrentBalance from './CurrentBalance'
import TransactionsContainer from './TransactionsContainer'

const AccountHistoryContainer = ({ className }) => {
  const { data, refetch, error } = useCamelQuery(GetCustomerAccountHistoryDocument)

  useLogAndCaptureError(error)

  if (!data || !data.getCustomerAccountHistory) {
    return <Spinner loading />
  }

  return (
    <div className={className}>
      <HeaderWithSecondaryButton
        buttonText="refresh"
        headerText="Account History"
        onClick={() => refetch()}
      />
      <CurrentBalance accountHistory={data.getCustomerAccountHistory} />
      <TransactionsContainer transactions={data.getCustomerAccountHistory.transactions} />
    </div>
  )
}

AccountHistoryContainer.defaultProps = {
  className: '',
}

AccountHistoryContainer.propTypes = {
  className: PropTypes.string,
}

const StyledAccountHistoryContainer = styled(AccountHistoryContainer)({})

export default StyledAccountHistoryContainer
